import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

const UserECheckPaymentMethodDetails = ({ paymentDetails = {} }) => {
  const {
    id,
    account_number,
    account_type,
    bank_name,
    echeck_type,
    is_default,
    name_on_account,
    profile_type,
    routing_number,
  } = paymentDetails;

  return (
    <table className={cn('table', 'table-striped', styles.table)}>
      <tbody>
        <tr>
          <th>ID</th>
          <td>{id}</td>
        </tr>
        <tr>
          <th>Account Number</th>
          <td>{account_number}</td>
        </tr>
        <tr>
          <th>Account Type</th>
          <td>{account_type}</td>
        </tr>
        <tr>
          <th>Bank Name</th>
          <td>{bank_name}</td>
        </tr>
        <tr>
          <th>Echeck Type</th>
          <td>{echeck_type}</td>
        </tr>
        <tr>
          <th>Name On Account</th>
          <td>{name_on_account}</td>
        </tr>
        <tr>
          <th>Profile Type</th>
          <td>{profile_type}</td>
        </tr>
        <tr>
          <th>Routing Number</th>
          <td>{routing_number}</td>
        </tr>
        <tr>
          <th>Is Default</th>
          <td>{is_default ? 'Yes' : 'No'}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default UserECheckPaymentMethodDetails;
